export enum PropertiesType {
  Text = 'text',
  Textarea = 'textarea',
  Number = 'number',
  Money = 'money',
  Date = 'date',
  Select = 'select',
  MultiSelect = 'multi-select',
}

export enum PropertiesContext {
  Text = 'Kiểu chữ',
  Textarea = 'Kiểu văn bản',
  Number = 'Kiểu số',
  Money = 'Kiểu tiền',
  Date = 'Kiểu ngày tháng',
  Select = 'Kiểu chọn một giá trị',
  MultiSelect = 'Kiểu chọn nhiều giá trị',
}

export const DefaultField = [
  'user_id',
  'updated_at',
  'time_start',
  'time_end',
  'tenant_id',
  'subject',
  'status',
  'source_detail',
  'source',
  'requester_id',
  'receiver_id',
  'finisher',
  'created_at',
  'code',
  'call_type',
  'call_status',
  'call_id',
  'assign_group_id',
  'assign_agent_id',
  '_id',
  '__v',
];
export class PropertiesConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên thuộc tính',
        key: 'title',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Key thuộc tính',
        key: 'key',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Kiểu',
        key: 'display_type',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static displayTypeColumn = type => {
    let html = `<small class="badge badge-primary">`;
    switch (type) {
      case PropertiesType.Text:
        html += PropertiesContext.Text;
        break;
      case PropertiesType.Textarea:
        html += PropertiesContext.Textarea;
        break;
      case PropertiesType.Number:
        html += PropertiesContext.Number;
        break;
      case PropertiesType.Money:
        html += PropertiesContext.Money;
        break;
      case PropertiesType.Date:
        html += PropertiesContext.Date;
        break;
      case PropertiesType.Select:
        html += PropertiesContext.Select;
        break;
      case PropertiesType.MultiSelect:
        html += PropertiesContext.MultiSelect;
        break;
      default:
        html += type;
    }
    return html + `</small>`;
  };
  static PropertiesArray = () => {
    return [
      { id: PropertiesType.Text.toString(), text: PropertiesContext.Text },
      {
        id: PropertiesType.Textarea.toString(),
        text: PropertiesContext.Textarea,
      },
      { id: PropertiesType.Number.toString(), text: PropertiesContext.Number },
      // {id: PropertiesType.Money.toString(), text: PropertiesContext.Money},
      { id: PropertiesType.Date.toString(), text: PropertiesContext.Date },
      { id: PropertiesType.Select.toString(), text: PropertiesContext.Select },
      {
        id: PropertiesType.MultiSelect.toString(),
        text: PropertiesContext.MultiSelect,
      },
    ];
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/properties/properties.const.ts